/* istanbul ignore file */
// It is a fire and forget sender that is not unit-testable.

import { InternalEventsSender } from "./InternalEventsSender";
import { DEFAULT_BASE_URL } from "./InternalEventsBaseUrls";

export class DefaultInternalEventsSender implements InternalEventsSender {
	constructor(private readonly baseUrl = DEFAULT_BASE_URL) {
		// intentionally left empty
	}

	sendEvent(eventData: Record<string, string>): void {
		eventData.r = (Math.floor(Math.random() * 9999) + 1).toString();
		const queryString = new URLSearchParams(eventData);
		const anImage = new Image(1, 1);
		anImage.src = `${this.baseUrl}?${queryString}`;
	}
}
